import React from 'react'
import { useDispatch } from 'react-redux'
import { useSelector, useMakeSelector } from 'hooks/redux'
import styled from '@emotion/styled'
import strings from 'utils/strings'
import { LIST, DASH_VIEW } from 'utils/constants'
import { removeComponent } from 'actions/dash'
import { setSelectedIdWithDrawerAndMeta } from 'actions/navigator'
import { makeComponentMetaSelector } from 'selectors/navigator'
import { getAllDashComponents } from 'selectors/dash'
import { Icon, Paragraph, Button } from 'components/patterns'
import LinkedLogicsList from 'components/LinkedLogicsList/'
import { Content, Footer } from 'components/SwitchAndGauge/DashDrawer/Sections'
import PanelPartDetails from 'components/SwitchAndGauge/DashDrawer/PanelPartDetails'
import { StyledViewWrap } from './style'

const RemoveView = () => {
  const dispatch = useDispatch()
  const { id: drawerId } = useMakeSelector(makeComponentMetaSelector, {
    id: DASH_VIEW,
  })

  const components = useSelector(getAllDashComponents)
  const { switchId, isNative } = components[drawerId]

  const handleCancel = () => {
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: LIST,
      })
    )
  }

  const handleRemove = () => {
    dispatch(removeComponent(drawerId))
    dispatch(
      setSelectedIdWithDrawerAndMeta(DASH_VIEW, {
        view: LIST,
      })
    )
  }

  return (
    <StyledViewWrap>
      <RemovalContent>
        <HeaderContainer>
          <StyledIcon
            icon="alert_exclamation_triangle_solid"
            fill="warningPrimary"
          />
          <StyledParagraphOne>{`${strings.remove_this_switch}?`}</StyledParagraphOne>
        </HeaderContainer>
        <HelperText>{strings.remove_switch_helper}</HelperText>
        {switchId && !isNative && (
          <FeaturesList>
            <Paragraph>
              {strings.the_following_features_will_be_removed}:
            </Paragraph>
            <StyledLinkedLogicsList
              associatedControl="switch"
              switchId={switchId}
            />
          </FeaturesList>
        )}
        <PanelPartDetails hideLinkedLogics />
      </RemovalContent>
      <Footer>
        <FooterContent>
          <div>
            <Button
              type="secondary"
              onClick={handleCancel}
              doMargins={false}
              style={{ marginLeft: 0 }}
            >
              {strings.cancel}
            </Button>
          </div>
          <RightGroup>
            <SaveWarning>{strings.remove_switch_save_warning}</SaveWarning>
            <div>
              <Button
                type="danger"
                onClick={handleRemove}
                doMargins={false}
                style={{ marginRight: 0 }}
              >
                {strings.remove_switch}
              </Button>
            </div>
          </RightGroup>
        </FooterContent>
      </Footer>
    </StyledViewWrap>
  )
}

export default RemoveView

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
`

const StyledParagraphOne = styled(Paragraph)`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  display: inline-block;
  margin: 0;
`

const StyledIcon = styled(Icon)`
  font-size: 22px;
`

export const HelperText = styled(Paragraph)`
  font-size: 14px;
  line-height: 24px;
  margin-top: 4px;
  margin-bottom: 16px;
`

const StyledLinkedLogicsList = styled(LinkedLogicsList)`
  > p:first-of-type {
    display: none;
  }
  > p:last-of-type {
    margin-top: 4px;
    font-size: 14px;
  }
`

const FeaturesList = styled.div`
  margin: 16px 0 32px;
`

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  padding-top: 14px;
`

export const RightGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
`

export const RemovalContent = styled(Content)`
  padding-bottom: 16px;
`

const SaveWarning = styled(Paragraph)`
  font-size: 14px;
  line-height: 18px;
  text-align: right;
  margin: 0;
  width: 175px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.blackSecondary};
`
